var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex-container" }, [
    _c("div", { staticClass: "forgot-whitebox" }, [
      _c("p", { staticClass: "pass-desc" }, [
        _vm._v(
          " Enter your email address to receive instruction for resetting your password. "
        ),
      ]),
      _c("div", { staticClass: "forgot-container" }, [
        _c("div", { staticClass: "forgot-input form-group col-sm-12" }, [
          _c("label", { attrs: { for: "email" } }, [_vm._v("Email")]),
          _c("span", { staticClass: "required_astric" }, [_vm._v("*")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.email,
                expression: "email",
              },
            ],
            staticClass: "forgot-input-box required form-control",
            attrs: { type: "email", placeholder: "E-mail Address" },
            domProps: { value: _vm.email },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.email = $event.target.value
              },
            },
          }),
        ]),
      ]),
      _c("div", { staticClass: "col-sm-12 emergo-button" }, [
        _c(
          "button",
          {
            staticClass: "btn emergo-green-button",
            attrs: { type: "button", disabled: _vm.disableButton },
            on: { click: _vm.postEmail },
          },
          [_vm._v(" " + _vm._s(_vm.btnTxt) + " ")]
        ),
      ]),
      _vm._m(0),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "footer-desc" }, [
      _vm._v(" Contact RAMS Support at "),
      _c("a", { attrs: { href: "mailto:ramshelp@ul.com" } }, [
        _vm._v("ramshelp@ul.com"),
      ]),
      _vm._v(" in case if didn't receive the email to reset password. "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }